import React, { useState } from 'react'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { CaptableManagementBreadCrumbs } from '../core/_constants'
import { DataTableServerSideWaterfallStakeholder } from './DataTableServerSideWaterfallStakeholder'
import { DataTableServerSideWaterfallShareClass } from './DataTableServerSideWaterfallShareClass'
import { DataTableServerSidePayoutSummary } from './DataTableServerSidePayoutSummary'
import { LineChartWithDataWaterfall } from './LineChartDataWaterFall'
import { LineChartWithDataWaterfallShareClass } from './LineChartDataWaterFallShareClass'
import brandingConfig from '../../../../config/brandingConfig'

const WaterfallDetails = () => {

    const { formatMessage } = useIntl()// eslint-disable-next-line 
    const [grossRevenue, setGrossRevenue] = useState<any>()
    const [stakeholder, setStakeholder] = useState(true) // eslint-disable-next-line 
    const handleStakeholder = function () {
        setStakeholder(() => !stakeholder)
        setShareClass(() => !shareClass)
    }
    const [shareClass, setShareClass] = useState(false)
    const handleShareClass = function () {
        setShareClass(() => !shareClass)
        setStakeholder(() => !stakeholder)
    }

    return (
        <div className='px-6'>
            <PageTitle
                breadcrumbs={CaptableManagementBreadCrumbs}
                description={formatMessage({ id: 'Performa' })}
            >
                {formatMessage({ id: 'Cap Table Management' })}
            </PageTitle>
            <div className='w-100'>
                <InfoCard2
                    title={formatMessage({ id: 'How to Manage Your Cap Table Efficiently?' })}
                    desc={formatMessage({
                        id: `${brandingConfig.brandName}’s Cap Table Management feature offers a seamless and organized approach to track your equity, project future ownership scenarios, and analyze management events.`,
                    })}
                    slug={brandingConfig.helpLinks.captableManagementDashboardOverview}
                    className='w-100 mb-0'
                />
            </div>
            <div className='bg-white w-100 border px-3 py-4 rounded mb-4'>
                <div className='d-flex flex-md-row flex-column justify-content-between align-items-center'>
                    <div className='d-flex flex-column justify-content-start w-100'>
                        <h1 className='font-size-16'>Scenario Sept 2024</h1>
                        <p className='font-size-13 text-muted m-0 mb-2'>Scenario Name</p>
                    </div>
                    <div className='d-flex flex-column justify-content-start w-100'>
                        <h1 className='font-size-16'>20 Sept 2024</h1>
                        <p className='font-size-13 text-muted m-0 mb-2'>Exit Date</p>
                    </div>
                    <div className='d-flex flex-column justify-content-start w-100'>
                        <h1 className='font-size-16'>USD 20,00,000</h1>
                        <p className='font-size-13 text-muted m-0 mb-2'>Exit Value</p>
                    </div>
                    <div className='d-flex flex-column justify-content-start w-100'>
                        <h1 className='font-size-16'>USD 1,00,000</h1>
                        <p className='font-size-13 text-muted m-0 mb-2'>Non Convertible Debt</p>
                    </div>
                </div>
            </div>
            <div>
                <h1 className='font-size-16'>{formatMessage({ id: 'Payout' })}</h1>
                <p className='text-muted'>{formatMessage({ id: 'View proceeds and metrics by share classes and top stakeholders for the exit.' })}</p>
            </div>
            <div className='bg-white rounded-top d-flex flex-column justify-content-between align-items-center p-6'>
                <div className='d-md-flex justify-content-between align-items-center w-100 px-4'>
                    <p className='text-muted m-0 font-size-14 mb-4 mb-md-auto'>{formatMessage({ id: 'Sensitivity Analysis' })}</p>
                    <div>
                        <button className={`w-50 w-md-auto btn border py-2 fs-6 ${stakeholder ? 'btn-primary' : 'text-muted'}`} style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}
                            onClick={handleStakeholder}>{formatMessage({ id: 'By Stakeholder' })}</button>
                        <button className={`w-50 w-md-auto btn border py-2 fs-6 ${shareClass ? 'btn-primary' : 'text-muted'}`} style={{ borderTopRightRadius: '4px', borderBottomRightRadius: '4px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}
                            onClick={handleShareClass}>{formatMessage({ id: 'By Share Class' })}</button>
                    </div>
                </div>
                {/* <LineChartWithDataWaterfall className={''} compareData={grossRevenue?.cummulativeData} /> */}
                {stakeholder && <LineChartWithDataWaterfall className={''} compareData={grossRevenue?.cummulativeData} />}
                {shareClass && <LineChartWithDataWaterfallShareClass className={''} compareData={grossRevenue?.cummulativeData} />}
            </div>
            {stakeholder && <DataTableServerSideWaterfallStakeholder />}
            {shareClass && <DataTableServerSideWaterfallShareClass />}
            <div className='mb-8'>
                <h1 className='font-size-16 my-4'>{formatMessage({ id: 'Payout Summery' })}</h1>
                <DataTableServerSidePayoutSummary />
            </div>
        </div >
    )
}

export default WaterfallDetails
